import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import { modalDataAtom, modalStatusAtom } from "@/atom/modal";


export const useModal = () => {
    const [modalStatus, setModalStatus] = useAtom(modalStatusAtom);
    const [modalData, setModalData] = useAtom(modalDataAtom);

    const open = useCallback((id: string, data?: any) => {
        setModalStatus(prev => ({
            ...prev,
            [id]: true
        }));
        setModalData(prev => ({
            ...prev,
            [id]: data
        }));
    }, [setModalStatus, setModalData]);

    const close = useCallback((id: string) => {
        setModalStatus(prev => ({
            ...prev,
            [id]: false
        }));
        setTimeout(() => {
            setModalData(prev => ({
                ...prev,
                [id]: undefined
            }));
        }, 300);
    }, [setModalStatus, setModalData]);

    const getData = useCallback((id: string) => {
        return modalData[id];
    }, [modalData]);

    const clear = useCallback(() => {
        setModalStatus({});
    }, [setModalStatus]);

    return useMemo(() => {
        return {
            open,
            close,
            clear,
            status: modalStatus,
            getData
        };
    }, [open, close, clear, getData, modalStatus]);
};
